import { Box } from "@mui/material";
import { Typography } from "@mui/material";
import React from "react";
import { styled } from "@mui/material";

export const Caixa = styled(Box)(({ theme }) => ({
	backgroundColor: "white",
	borderRadius: 50,
	padding: 100,
	width: "60%",
	[theme.breakpoints.down("sm")]: {
		backgroundColor: "white",
		width: "85%",
		borderRadius: 0,
		padding: 30,
		paddingTop: 100,
		paddingBottom: 100,
	},
}));

const QuiSom = () => {
	return (
		<Caixa>
			<Typography variant="h2" color="third">
				QUI SOM?
			</Typography>
			<Box mt={3}>
				<Typography variant="body1">
					Som un projecte educatiu que veu la llum l’estiu del 2013
					per donar un impuls a la necessitat de PROFESSIONALITZAR les
					activitats extraescolars de Berga i la comarca del Berguedà.
				</Typography>
				<Box my={3} />
				<Typography variant="body1">
					SINAPSIS neix de la inquietud de professionals del lleure,
					l’educació i l’esport per tal d’oferir un servei ampli, de
					qualitat i proper a les famílies del nostre entorn.
				</Typography>
				<Box my={3} />
				<Typography variant="body1">
					L’experiència ens permet ser referents a la ciutat,
					treballant en totes les escoles de Berga. Col·laborem amb
					les AMPA’s per tal de realitzar activitats que s’adequin a
					la demanda de les escoles, prioritzant l’alumnat amb
					personal qualificat i les bases legals cobertes.
				</Typography>
				<Box my={3} />
				<Typography variant="body1">
					El respecte, l’empatia i l’aprenentatge dels infants son les
					bases de les activitats de SINAPSIS. Treballem amb alegria,
					il·lusió i vetllem per tenir una bona comunicació amb les
					famílies.
				</Typography>
				<Box my={3} />
				<Typography variant="body1">
					Ens agrada col·laborar amb altres entitats, per això tenim
					convenis amb altres empreses i clubs per tal de sumar i
					enriquir la nostra tasca.
				</Typography>
			</Box>
		</Caixa>
	);
};

export default QuiSom;
